import styled from "@emotion/styled";
import { Box, BoxProps } from "@mui/material";
import { Typography } from "@avenue-8/sidekick-ui";

export const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2.5rem 3rem;
  border-radius: 1rem;
  background-color: ${(p) => p.theme.colors.background};
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  color: ${(p) => p.theme.text.colors.primary};

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    img {
      width: 150px;
    }
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 1.5rem;
  }
`;

export const ErrorMessage = styled.p`
  color: ${(p) => p.theme.colors.error};
  border-radius: 0.5rem;
  margin: 1rem 0;
  text-align: center;
`;

export const ValidationSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease-in-out;
  max-height: 1000px;
  /* grab the aria disabled */
  &[aria-hidden="true"] {
    margin-bottom: 0;
    opacity: 0;
    max-height: 0;
  }
`;

export const ValidationSummaryItem = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  margin-top: 1rem;
`;

export const ClientName = styled.span`
  font-weight: 900;
  &:hover {
    cursor: default;
  }
`;

export const Card: React.FC<BoxProps> = styled(Box)`
  border: ${(p) => p.theme.colors.border} solid 1px;
  padding: 1.5rem;
  border-radius: 1rem;
`;
export const InfoTextBlock = styled(Typography)`
  strong {
    display: inline-block;
  }
  span {
    display: inline-block;
    padding: 0.25rem 1rem;
  }
`;

export const SelectedLoginOption = styled.div`
  display: flex;
  border: solid 1px ${(p) => p.theme.colors.border2};
  border-radius: 0.5rem;
  padding: 1rem;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 1rem;

  p {
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }

  &:hover {
    border: solid 1px ${(p) => p.theme.colors.border};
  }
`;

export const MembershipAffiliationContainer = styled.div`
  &[aria-disabled="true"] {
    opacity: 0.5;
    pointer-events: none;
  }
`;
